import styled from "styled-components";

export const HeaderSection = styled("header")`
  padding: 1rem 0.5rem;
  border-bottom: 1px solid #1E3050;
  background: rgba(6, 13, 26, 0.92);
  backdrop-filter: blur(12px);
  position: sticky;
  top: 0;
  z-index: 100;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DrawerOverlay = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(6, 13, 26, 0.7);
  z-index: 999;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  pointer-events: ${({ $open }) => ($open ? "all" : "none")};
  transition: opacity 0.25s ease;
`;

export const DrawerPanel = styled.div<{ $open: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  max-width: 88vw;
  height: 100dvh;
  background: #0A1628;
  z-index: 1000;
  padding: 2rem 1.5rem;
  border-left: 1px solid #1E3050;
  transform: ${({ $open }) => ($open ? "translateX(0)" : "translateX(100%)")};
  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};
  transition: transform 0.3s ease,
              visibility 0s linear ${({ $open }) => ($open ? "0s" : "0.3s")};
`;

export const DrawerClose = styled.button`
  position: absolute;
  top: 1rem;
  right: 1.25rem;
  background: none;
  border: none;
  color: #6E89AA;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  padding: 0.25rem;
  transition: color 0.2s;

  &:hover {
    color: #EDF2FF;
  }
`;

export const LogoContainer = styled("div")`
  display: flex;
  align-items: center;
`;

export const LogoWrapper = styled("div")`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  cursor: pointer;
`;

export const WordmarkText = styled("span")`
  font-size: 1.15rem;
  line-height: 1;

  .wm-my {
    font-family: 'Manrope', sans-serif;
    font-weight: 300;
    color: rgba(237, 242, 255, 0.45);
  }

  .wm-exam {
    font-family: 'Fraunces', Georgia, serif;
    font-weight: 700;
    color: #E8A020;
  }

  .wm-nation {
    font-family: 'Manrope', sans-serif;
    font-weight: 500;
    color: rgba(237, 242, 255, 0.9);
  }
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const NavItem = styled("span")`
  font-family: 'Manrope', sans-serif;
  font-size: 0.88rem;
  font-weight: 500;
  color: #6E89AA;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #EDF2FF;
  }
`;

export const NavCta = styled("span")`
  font-family: 'Manrope', sans-serif;
  font-size: 0.82rem;
  font-weight: 700;
  color: #060D1A;
  background: #E8A020;
  padding: 0.5rem 1.1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.15s ease;

  &:hover {
    opacity: 0.88;
    transform: translateY(-1px);
  }
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;
  cursor: pointer;

  svg {
    fill: #060D1A;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("nav")`
  display: flex;
  align-items: center;
  gap: 2rem;
  margin: 0;
  padding: 0;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #18216d;
  transition: color 0.2s ease-in;
  margin: 0.5rem 2rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;


export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: rgb(255, 130, 92);
    text-underline-position: under;
    text-decoration: rgb(255, 130, 92) wavy underline;
  }
`;

export const AccountWrap = styled("div")`
  position: relative;
  display: flex;
  align-items: center;
`;

export const AvatarButton = styled("button")`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #1E3050;
  background: #0C1628;
  color: #E8A020;
  font-family: 'Manrope', sans-serif;
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s;

  &:hover {
    border-color: #E8A020;
  }
`;

export const AccountMenu = styled.div<{ $open: boolean }>`
  position: absolute;
  top: calc(100% + 0.6rem);
  right: 0;
  min-width: 210px;
  background: #0A1628;
  border: 1px solid #1E3050;
  border-radius: 10px;
  padding: 0.5rem;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);
  display: ${({ $open }) => ($open ? "block" : "none")};
`;

export const AccountEmail = styled("div")`
  font-family: 'Manrope', sans-serif;
  font-size: 0.78rem;
  color: #6E89AA;
  padding: 0.5rem 0.65rem 0.6rem;
  border-bottom: 1px solid #1E3050;
  margin-bottom: 0.35rem;
  word-break: break-all;
`;

export const AccountMenuItem = styled("button")`
  display: block;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 0.65rem;
  font-family: 'Manrope', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #EDF2FF;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #0C1628;
  }
`;

export const DrawerDivider = styled("div")`
  width: 100%;
  height: 1px;
  background: #1E3050;
  margin: 0.25rem 0;
`;

export const DrawerUserEmail = styled("span")`
  font-family: 'Manrope', sans-serif;
  font-size: 0.78rem;
  color: #6E89AA;
  word-break: break-all;
`;
